// Receita RECONHECIDA de um projeto num mês (mesma lógica do FinancialPage byClient).
// Mensal fixo: valor/mês. Único/Por marco: no mês de início. Pré-pago: diluído pelos meses. 
export function reconhecidoProjetoMes(p, ym){
  if(!p) return 0;
  const bm = p.billing_model;
  if(bm==='Mensal fixo'){
    if(!p.contract_start||!p.contract_end) return 0;
    const start=p.contract_start.slice(0,7);
    const eD=new Date(p.contract_end); const last=new Date(eD); last.setDate(last.getDate()-1);
    const lastYM=last.getFullYear()+'-'+String(last.getMonth()+1).padStart(2,'0');
    return (ym>=start && ym<=lastYM) ? (p.value||0) : 0;
  }
  if(bm==='Único' || bm==='Por marco'){
    return (p.contract_start?.slice(0,7)===ym) ? (p.value||0) : 0;
  }
  if(bm==='Pré-pago'){
    if(!p.contract_start||!p.contract_end) return 0;
    const sD=new Date(p.contract_start), eD=new Date(p.contract_end);
    const last=new Date(eD); last.setDate(last.getDate()-1);
    const sy=sD.getFullYear(), sm=sD.getMonth()+1, ly=last.getFullYear(), lm=last.getMonth()+1;
    const nMeses=(ly-sy)*12+(lm-sm)+1;
    const startYM=p.contract_start.slice(0,7);
    const lastYM=ly+'-'+String(lm).padStart(2,'0');
    return (ym>=startYM && ym<=lastYM && nMeses>0) ? (p.value||0)/nMeses : 0;
  }
  return 0; // 'Por sessão' vem das sessions, não do projeto
}
